import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

const LABELS = {
  daily_brief_manual: "Brief regens",
  market_explain: "Market AI",
  signal_narrative: "Signal AI",
  trader_summary: "Trader AI",
  analyst_answer: "Analyst AI",
  contrarian_report: "Contrarian AI",
  watchlist_copilot: "Watchlist AI",
  chat_assistant: "Chat AI",
};

export function useAIQuotas() {
  return useQuery({
    queryKey: ["ai-quotas"],
    queryFn: async () => (await api.get("/intel/ai/quotas")).data.quotas,
    staleTime: 60_000,
    refetchInterval: 120_000,
  });
}

export default function AIQuotaBadge({ endpoint, compact = false, className = "" }) {
  const { data } = useAIQuotas();
  const q = data?.[endpoint];
  if (!q) return null;
  const exhausted = q.remaining <= 0;
  const reset = q.reset_at ? new Date(q.reset_at).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }) : "later";
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] ${
        exhausted
          ? "border-rose-500/30 bg-rose-500/10 text-rose-300"
          : q.remaining <= Math.max(1, Math.floor(q.limit * 0.2))
          ? "border-amber-500/30 bg-amber-500/10 text-amber-300"
          : "border-zinc-700 bg-zinc-900 text-zinc-400"
      } ${className}`}
      title={`${LABELS[endpoint] || endpoint}: ${q.remaining}/${q.limit} remaining. Resets at ${reset}.`}
      data-testid={`ai-quota-${endpoint}`}
    >
      {compact ? `${q.remaining}/${q.limit}` : `${LABELS[endpoint] || endpoint}: ${q.remaining}/${q.limit} left`}
    </span>
  );
}
